import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  guards: [],
  loading: false,
  error: null,
};

const guardsSlice = createSlice({
  name: 'guards',
  initialState,
  reducers: {
    setGuards: (state, action) => {
      state.guards = action.payload;
    },
    addGuard: (state, action) => {
      state.guards.push(action.payload);
    },
    updateGuard: (state, action) => {
      const index = state.guards.findIndex(guard => guard.id === action.payload.id);
      if (index !== -1) {
        state.guards[index] = action.payload;
      }
    },
    deleteGuard: (state, action) => {
      state.guards = state.guards.filter(guard => guard.id !== action.payload);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setGuards,
  addGuard,
  updateGuard,
  deleteGuard,
  setLoading,
  setError,
} = guardsSlice.actions;

export default guardsSlice.reducer; 